import { pad } from './strings'

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
function isLeapyear(year: number) {
  return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0
}
export const daysInMonth = (year: number) =>
  isLeapyear(year)
    ? [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    : [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
export const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]
export const hours = new Array(24).fill(0).map((_, ind) => {
  const meridain = ind > 11 ? 'pm' : 'am'
  if ((ind + 12) % 12 === 0) {
    return (ind === 0 ? ind + 12 : 12) + ':00' + meridain
  } else {
    return pad((ind + 12) % 12, 2) + ':00' + meridain
  }
})
export const getYearsFrom = (year: number) => {
  const options = []
  const thisYear = new Date().getFullYear()
  const yearsDifference = thisYear - year
  for (let i = 0; i <= yearsDifference; i++) {
    options.push(thisYear - i)
  }
  return options
}
export const convertToLocalTime = (str: string) => {
  try {
    const date = new Date(str)

    const timeLocal = date.toLocaleTimeString()
    const transformedTime = timeLocal.split(':').map(Number)
    // new Date(
    //   date.getFullYear(),
    //   date.getMonth(),
    //   date.getDate(),
    //   transformedTime[0],
    //   transformedTime[1],
    //   transformedTime[2]
    // );
    return date
  } catch (err) {
    return str
  }
}

export const getMeridian = (str: string) => {
  const date = convertToLocalTime(str)
  if (typeof date === 'string') return str
  return date.getHours() >= 12 ? 'pm' : 'am'
}

export const getDateSurfix = (date: Date): string => {
  return (
    date.getDate() +
    (date.getDate() % 10 == 1 && date.getDate() != 11
      ? 'st'
      : date.getDate() % 10 == 2 && date.getDate() != 12
      ? 'nd'
      : date.getDate() % 10 == 3 && date.getDate() != 13
      ? 'rd'
      : 'th')
  )
}

export const getMonthFormat = (
  dateStr: string,
  format: 'MM' | 'MMMM' | 'mm'
) => {
  const date = convertToLocalTime(dateStr)
  if (typeof date === 'string') return dateStr
  let res
  if (format === 'MM') {
    res = months[date.getMonth()].substring(0, 3)
  }
  if (format === 'MMMM') {
    res = months[date.getMonth()]
  }
  if (format === 'mm') {
    res = date.getMonth() + 1
  }
  return res
}

function getTimeLeft(numberInSecs: number): [number, number, number] | number
function getTimeLeft(endDateStr: string): [number, number, number] | string
function getTimeLeft(
  value: number | string
): [number, number, number] | string | number {
  if (typeof value === 'string') {
    const today = convertToLocalTime(new Date().toISOString()) as Date
    const endDate = convertToLocalTime(value) as Date
    if (typeof today === 'string' || typeof endDate === 'string') return value
    const numberOfDays = getNumberOfDays(today, endDate)
    const numberOfHours = getHoursRemaining(numberOfDays, endDate)
    const numberOfMinutes = getMinutesRemaining(numberOfDays, endDate)

    return [numberOfDays, numberOfHours, numberOfMinutes]
  } else {
    const realNumber = Number(value)
    if (isNaN(realNumber)) return value
    const rawDays = value / (24 * 60 * 60)
    const numberOfDays = Math.floor(rawDays)
    const rawHours = (rawDays - numberOfDays) * 24
    const numberOfHours = Math.floor(rawHours)
    const numberOfMinutes = Math.floor((rawHours - numberOfHours) * 60)

    return [numberOfDays, numberOfHours, numberOfMinutes]
  }
}

export const isDayPreviousToThatDay = (thatDay: Date, dayAgainst: Date) => {
  return (
    Math.floor(thatDay.getTime() / (1000 * 60 * 60 * 24)) >
    Math.floor(dayAgainst.getTime() / (1000 * 60 * 60 * 24))
  )
}

export const isThatDay = (thatDay: Date, dayAgainst: Date) => {
  return (
    thatDay.getMonth() === dayAgainst.getMonth() &&
    thatDay.getDate() === dayAgainst.getDate() &&
    thatDay.getFullYear() === dayAgainst.getFullYear()
  )
}

export const isYesterday = (day: Date) => {
  const today = new Date()
  return (
    today.getMonth() === day.getMonth() &&
    today.getDate() - 1 === day.getDate() &&
    today.getFullYear() === day.getFullYear()
  )
}
export const isToday = (day: Date) => {
  const today = new Date()
  return (
    today.getMonth() === day.getMonth() &&
    today.getDate() === day.getDate() &&
    today.getFullYear() === day.getFullYear()
  )
}

export const isDayInBetweenDaysInclusive = (
  day: Date,
  startDate: Date,
  endDate: Date
) => {
  const isInMonth =
    day.getMonth() >= startDate.getMonth() &&
    day.getMonth() <= endDate.getMonth()
  const isInYear =
    day.getFullYear() >= startDate.getFullYear() &&
    day.getFullYear() <= endDate.getFullYear()
  if (!isInMonth || !isInYear) return false
  return (
    Math.floor(day.getTime() / (1000 * 60 * 60 * 24)) * 12 >=
      Math.floor(startDate.getTime() / (1000 * 60 * 60 * 24)) * 12 &&
    Math.floor(day.getTime() / (1000 * 60 * 60 * 24)) * 12 <=
      Math.floor(endDate.getTime() / (1000 * 60 * 60 * 24)) * 12
  )
}
export const getDaysBetweenInclusive = (
  startDate: Date,
  endDate: Date
): Date[] => {
  const dates: Date[] = []

  let currentDate = startDate
  while (currentDate <= endDate) {
    dates.push(new Date(currentDate))
    const date = new Date(currentDate)
    date.setDate(date.getDate() + 1)
    currentDate = date
  }

  return dates
}
export const getHoursBetweenInclusive = (
  startDate: Date,
  endDate: Date
): Date[] => {
  const dates: Date[] = []

  let currentDate = startDate
  while (currentDate <= endDate) {
    dates.push(new Date(currentDate))
    const date = new Date(currentDate)
    date.setHours(date.getHours() + 1)
    currentDate = date
  }

  return dates
}
export const isDayFutureToThatDay = (thatDay: Date, dayAgainst: Date) => {
  return (
    Math.floor(thatDay.getTime() / (1000 * 60 * 60 * 24)) <
    Math.floor(dayAgainst.getTime() / (1000 * 60 * 60 * 24))
  )
}
export const isFutureDays = (day: Date) => {
  const today = new Date()
  return (
    Math.floor(today.getTime() / (1000 * 60 * 60 * 24)) <
    Math.floor(day.getTime() / (1000 * 60 * 60 * 24))
  )
}
export const isPrevDays = (day: Date) => {
  const today = new Date()

  return (
    Math.floor(today.getTime() / (1000 * 60 * 60 * 24)) >
    Math.floor(day.getTime() / (1000 * 60 * 60 * 24))
  )
}
export const isPrevMonth = (selectedDay: Date, day: Date) =>
  (selectedDay.getFullYear() === day.getFullYear() &&
    selectedDay.getMonth() === day.getMonth() + 1) ||
  (selectedDay.getFullYear() === day.getFullYear() + 1 &&
    selectedDay.getMonth() === 0 &&
    day.getMonth() === 11)
export const isNextMonth = (selectedDay: Date, day: Date) =>
  (selectedDay.getFullYear() === day.getFullYear() &&
    selectedDay.getMonth() === day.getMonth() - 1) ||
  (selectedDay.getFullYear() === day.getFullYear() - 1 &&
    selectedDay.getMonth() - 11 === day.getMonth())

export const getDateString = (date: Date) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
    date.getDate(),
    2
  )}`
}
export { getTimeLeft }
export const getNumberOfDays = (startDate: Date, endDate: Date) => {
  let days = 0
  if (startDate.getFullYear() != endDate.getFullYear()) {
    days += (endDate.getFullYear() - startDate.getFullYear()) * 365
  }
  if (startDate.getMonth() != endDate.getMonth()) {
    for (let i = startDate.getMonth(); i < endDate.getMonth(); i++) {
      days += daysInMonth(startDate.getFullYear())[i]
    }
  }
  days += endDate.getDate() - startDate.getDate()
  return days
}

const getHoursRemaining = (nDays: number, endDate: Date) => {
  const today = convertToLocalTime(new Date().toISOString()) as Date
  const millisecondsSofar = nDays * 24 * 60 * 60 * 1000
  const timeBetween = endDate.getTime() - today.getTime()

  return Math.floor((timeBetween - millisecondsSofar) / (1000 * 60 * 60))
}

const getMinutesRemaining = (nDays: number, endDate: Date) => {
  const today = convertToLocalTime(new Date().toISOString()) as Date
  const millisecondsSofar = nDays * 24 * 60 * 60 * 1000
  const timeBetween = endDate.getTime() - today.getTime()
  const hours = (timeBetween - millisecondsSofar) / (1000 * 60 * 60)
  const minute = (hours - Math.floor(hours)) * 60
  return Math.floor(minute)
}
